// DREAMINK ANIMATION ENGINE

document.addEventListener('DOMContentLoaded', () => {
  DreamInkAnimations.init();
});

const DreamInkAnimations = {
  init() {
    this.parallaxElements();
  },

  parallaxElements() {
    const elements = document.querySelectorAll('[data-parallax]');

    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;

      elements.forEach(el => {
        const speed = el.dataset.parallax || 0.2;
        el.style.transform = `translateY(${scrollY * speed}px)`;
      });
    });
  }
};